'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'square-6';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e25b';
var svgPathData = 'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM280 168c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24 10.7-24 24l0 12.1c7.5-2.7 15.6-4.1 24-4.1l32 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-32 0c-39.8 0-72-32.2-72-72l0-80c0-39.8 32.2-72 72-72l48 0c13.3 0 24 10.7 24 24zM208 320l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquare6 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;